import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, makeStyles, Paper, Tab, Tabs } from '@material-ui/core';
import clsx from 'clsx';
import { useState } from 'react';
import { pxToRem, transitionSpeed } from '../../theme';
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    tabs: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(0, 1),
    },
    tab: {
        background: 'none',
        border: 0,
        borderBottom: '3px solid transparent',
        color: theme.palette.text.disabled,
        fontSize: pxToRem(14),
        fontWeight: 400,
        lineHeight: pxToRem(21),
        minWidth: 0,
        opacity: 1,
        padding: theme.spacing(0, 2),
        height: 52,
        textDecoration: 'none',
        textTransform: 'capitalize',
        transition: `${transitionSpeed}`,
        width: 'auto',
        '&:hover': {
            opacity: 1,
        },
        '&.Mui-selected': {
            fontWeight: 600,
            color: theme.palette.text.primary,
        },
    },
    indicator: {
        height: 3,
        backgroundColor: theme.palette.primary.main,
    },
    content: {
        padding: theme.spacing(2, 0),
    },
    activeTab: {
        borderBottom: `3px solid ${theme.palette.primary.main}`,
    },
}));
export const TabbedContent = ({ tabs, children, defaultTab, onTabChange, className }) => {
    const classes = useStyles();
    //set default tab or use the first tab
    const defaultIndex = defaultTab ? tabs.findIndex((tab) => tab.id === defaultTab) : 0;
    const [activeTab, setActiveTab] = useState(defaultIndex >= 0 ? defaultIndex : 0);
    const handleTabChange = (__, newValue) => {
        setActiveTab(newValue);
        if (onTabChange) {
            onTabChange(tabs[newValue].id);
        }
    };
    return (_jsx("div", { className: clsx(classes.root, className && className), children: _jsxs(Paper, { elevation: 0, children: [_jsx(Box, { className: classes.tabs, children: _jsx(Tabs, { value: activeTab, onChange: handleTabChange, "aria-label": 'tabbed content navigation', classes: { indicator: classes.indicator }, variant: 'scrollable', scrollButtons: 'auto', children: tabs.map((tab) => (_jsx(Tab, { label: tab.label, id: `tab-${tab.id}`, "aria-controls": `tabpanel-${tab.id}`, className: classes.tab, disableRipple: true }, tab.id))) }) }), _jsx(Box, { className: classes.content, role: 'tabpanel', id: `tabpanel-${tabs[activeTab].id}`, "aria-labelledby": `tab-${tabs[activeTab].id}`, children: children })] }) }));
};
